<template>
  <div class="secondPage">
    <Header></Header>
    <NavBar :navlist="navList"
            :activedNum="menuId"></NavBar>
    <!-- <guanggao></guanggao> -->
    <div class="contentWrap width1000 clearFix">
      <div class="lf_content">
        <div class="breadNav">
          <a class="text"
             href="/h5/index.html">慈善中国</a>
          <span>>></span>
          <a class="text"
             :href="'/h5/index.html?menuId='+menuId">{{dataList.menuName}}</a>
          <span>>></span>
          <a class="list">列表</a>
        </div>
        <div class="news">
          <div class="list-item"
               v-for="(item,index) in dataList.list"
               :key="index">
            <div :class="(index+1)%10==0&&index!=0&&index!=29?'list-lf border_bt':'list-lf'">
              <a :href="'/h5/detail.html?artId='+item.artId"
                 target="_blank "
                 class="title
                 ">{{item.artTitle}}</a>
              <span class="time
                 ">{{item.publishTime | toChangeTime}}</span>
            </div>
          </div>
        </div>
        <div class="pages">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         layout="prev, pager, next"
                         :page-size="dataList.pageSize"
                         :total="dataList?dataList.total:'1'">
          </el-pagination>
        </div>
      </div>
      <!-- <div class="rf_content">
        <div class="module_item type1">
          <h2 class="bigTitle">名家访谈</h2>
          <div class="content">
            <div class="imgBox">
              <a href="#"
                 target="_blank"><img src="http://culture.people.com.cn/NMediaFile/2020/0619/MAIN202006190959388381526480617.jpg"
                     width="310"
                     height="171"
                     border="0"
                     alt="范迪安：美绘乡村 打造壁画艺术村
        美术和美术教育，在脱贫攻坚和全面建成小康社会等历史任务面前是大有可为、大有作为的。发挥美育作用多培养人才，却能够管用一辈子。"></a>
            </div>
            <div class="info">
              <a href="#"
                 target="_blank">
                <strong>范迪安：美绘乡村 打造壁画艺术村</strong>
                <p class="gray2">美术和美术教育，在脱贫攻坚和全面建成小康社会等历史任务面前是大有可为、大有作为的。发挥美育作用多培养人才，却能够管用一辈子。</p>
              </a>
            </div>
          </div>
        </div>
        <div class="type1">
          <h2 class="bigTitle">人民娱评</h2>
          <div class="content">
            <div class="imgBox">
              <a href="#"
                 target="_blank"><img src="http://culture.people.com.cn/NMediaFile/2020/0622/MAIN202006221810586587800250591.jpg"
                     width="310"
                     height="171"
                     border="0"
                     alt="范迪安：美绘乡村 打造壁画艺术村
        美术和美术教育，在脱贫攻坚和全面建成小康社会等历史任务面前是大有可为、大有作为的。发挥美育作用多培养人才，却能够管用一辈子。"></a>
            </div>
            <div class="info">
              <a href="#"
                 target="_blank">
                <strong>司长说非遗：感受非遗的温度</strong>
                <p class="gray2">胡雁在与网友互动的同时，为大家带来一场名副其实的非遗“盛宴”。</p>
              </a>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/index/header.vue';
import NavBar from '@/components/index/navBar.vue';
import guanggao from '@/components/index/guanggao.vue';//广告
import Footer from '@/components/index/footer.vue';
import ajaxUtil from "@/assets/js/ajax.js";
import tools from "@/assets/js/utils.js";
import moment from 'moment';

export default {
  data () {
    return {
      menuId: "",
      dataList: [],
      navList: "",
    }
  },
  components: {
    Header,
    NavBar,
    guanggao,
    Footer
  },
  created () {
    this.getMenuId();
  },
  mounted () {
    this.getNavBar();
    this.getMenuId();
    this.init();
  },
  computed: {

  },
  filters: {
    toChangeTime: function (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },

  methods: {
    getNavBar () {
      var that = this;
      ajaxUtil.post('/api/web/menus/v1', {

      }).then(({ data }) => {

        that.navList = data;

      }).catch((err) => {

      });
    },
    getMenuId () {
      var menuId = tools.getUrlPara('menuId');
      this.menuId = menuId;
    },
    init (currentPage, pageSize) {
      if (currentPage) {
        currentPage = currentPage
      } else {
        currentPage = 1
      }
      if (pageSize) {
        pageSize = pageSize;
      } else {
        pageSize = 20;
      }

      var that = this;
      ajaxUtil.post('/api/web/article/list/v1', {
        menuId: this.menuId,
        currentPage: currentPage,
        pageSize: pageSize,

      }).then(({ data }) => {
        this.dataList = data;
        // console.log(data);
      }).catch((err) => {

      });
    },
    //pageSize 改变时会触发；
    handleSizeChange (val) {
      this.init(val);
    },
    handleCurrentChange (val) {
      this.init(val);
    },
    newsCount () {
      var count = this.dataList.length;

    }
  }
}
</script>

<style lang="less">
.secondPage {
  .footer {
    margin-top: 60px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #e60012;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #e60012;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active:hover {
    color: #fff;
  }
  .contentWrap {
    margin-top: 16px;
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    .border_bt:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background: #dddddd;
      margin: 20px 0;
    }
    .lf_content {
      width: 66%;
      float: left;
      .breadNav {
        font: normal 12px/180% '宋体';
        height: 64px;
        line-height: 64px;
        border-bottom: 3px solid #efefef;
        .text,
        .list {
          margin: 0 6px;
        }
        .text:hover {
          color: #e60012;
          text-decoration: underline;
        }
      }

      .news {
        .list-item {
          margin-top: 10px;
          // .list-lf {
          //   border-bottom: 1px solid #dddddd;
          // }
          .title {
            display: inline-block;
            width: 90%;
            line-height: 32px;
            font-size: 16px;
          }
          .title:hover {
            color: #e60012;
            text-decoration: underline;
          }
          .time {
            color: #999;
          }
        }
      }
      .pages {
        margin: 20px 0;
        text-align: center;
      }
    }
    .rf_content {
      width: 310px;
      // background: pink;
      .bigTitle {
        height: 74px;
        line-height: 74px;
        font-size: 24px;
        color: #000;
      }
      .bigTitle:hover {
        cursor: pointer;
        color: #e60012;
        text-decoration: underline;
      }
      .type1 {
        .info {
          padding: 10px 20px;
          background: #f8f8f8;
          strong {
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
